"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserData = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _api = require("../api");
var _utils = require("../utils");
const useUserData = params => {
  const {
    customerId,
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    data,
    error
  } = (0, _fetching.useSWR)(isUserVerified && !isAnonymousUser ? [customerId, globalApiClient, tenant] : null, async () => (0, _api.getUserData)({
    customerId,
    globalApiClient,
    tenant
  }), {
    onSuccess: (0, _utils.onUserDataFetchSuccess)(params),
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  return {
    userData: data ?? {
      email: null,
      telephoneNumber: null
    },
    loading: !isAnonymousUser && data === undefined && error === undefined,
    error
  };
};
exports.useUserData = useUserData;
